import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { pullVcrControl, pullVcrControlComplete } from './sabre-engine.actions';
import { SabreEngineService } from '../sabre-engine.service';
import { loadVcr, ticketUpdateFromPullVcrCtrl } from '../../ticket-service/state/ticket-service.actions';
import { RootState } from '../../../state/state';
import { Store } from '@ngrx/store';
import { GetVcrType } from '../../../models/get-vcr-type';
import { PullVcrCtrlAndTicketDataResponse } from '../../../models/sabre-engine/pull-vcr-ctrl-and-ticket-data-response';
import { PullVcrCtrlResponse } from '../../../models/sabre-engine/pull-vcr-ctrl-response';
import { TicketResponse } from '../../../models/sabre-engine/ticket-response';

@Injectable()
export class SabreEngineEffects {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly actions$ = inject(Actions);
  private readonly sabreEngineService = inject(SabreEngineService);

  pullVcrControl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(pullVcrControl),
      mergeMap((action) => {
        const ticketNumbers = action.pullVcrCtrlRequest.ticketAndCoupons.map((ticket) => ticket.ticketNumber);
        return this.sabreEngineService.pullVcrControl(action.pullVcrCtrlRequest).pipe(
          map((response) => {
            const result = response as PullVcrCtrlAndTicketDataResponse;
            this.store.dispatch(loadVcr(ticketNumbers, false, GetVcrType.RESERVATION, false));
            this.store.dispatch(ticketUpdateFromPullVcrCtrl(result.ticketData.ticketDetails));
            return pullVcrControlComplete(false, result);
          }),
          catchError((err) => {
            let isGenericError = true;
            let result: PullVcrCtrlAndTicketDataResponse = null;

            if (err?.error?.ticketResponses?.length > 0) {
              isGenericError = false;
              const ticketResponses = err?.error?.ticketResponses as TicketResponse[];
              result = {
                pullVcrCtrlResponse: { ticketResponses } as PullVcrCtrlResponse,
                ticketData: null,
              } as PullVcrCtrlAndTicketDataResponse;
            }

            this.store.dispatch(loadVcr(ticketNumbers, false, GetVcrType.RESERVATION, false));
            return of(pullVcrControlComplete(isGenericError, result));
          })
        );
      })
    )
  );
}
